// extracted by mini-css-extract-plugin
module.exports = {"colorItem":"predefined-colors_colorItem__JH0Ha","selectedColorItem":"predefined-colors_selectedColorItem__2FTzw"};